<template>
    <div>
        <div>
            <div v-if="accessoryPrice.banner">
                <ob1-tag :label="accessoryPrice.banner" />
            </div>
            <promo-prix-terminal
                v-if="accessoryPrice.promotion"
                class="mt-1"
                :promo-label="accessoryPrice.promotion.label"
                :promo-end-date="accessoryPrice.promotion.endDate"
            />
            <ob1-prix
                :price="accessoryPrice.price.totalPriceWithPromo"
                :initial-price="accessoryPrice.price.totalPriceWithoutPromo"
                :price-without-promo="accessoryPrice.price.totalPriceWithoutPromo"
            />
            <cb4x-pxf-mention
                v-if="accessoryPrice.price.paymentInfoLabel"
                :payment-info-label="accessoryPrice.price.paymentInfoLabel.label"
                :payment-info-detail="accessoryPrice.price.paymentInfoLabel.detail"
                :link-label="accessoryPrice.paymentSolutionsDto.linkLabel"
                modal-id="popin-pxf-4xcb"
                is-from-mobile-detail
            />
            <!-- Popin de financement-->
            <pxf-cb4x-modal
                modal-id="popin-pxf-4xcb"
                :display-cb4x="accessoryPrice.price.cb4xAvailable"
                :display-pxf="accessoryPrice.price.pxfAvailable"
            >
                <template v-if="accessoryPrice.price.cb4xAvailable" #cb4x-content>
                    <!-- 4xCB payant  -->
                    <paying-detail-cb4x-modal-content
                        v-if="fundingDetails.cb4xPopin.withFees"
                        modal-id="popin-pxf-4xcb"
                        :oney-merchant-guid="fundingDetails.cb4xPopin.oneyMerchantGuid"
                        :oney-widget-src="fundingDetails.oneyWidgetSrc"
                        :counter-delay="fundingDetails.counterDelay"
                        :amount="accessoryPrice.price.totalPriceWithPromo"
                        :header-block="fundingDetails.cb4xPopin.headerBlock"
                        :payment-example-block="fundingDetails.cb4xPopin.paymentExampleBlock"
                        :how-to-benefit="fundingDetails.cb4xPopin.howToBenefit"
                        :cgu="fundingDetails.cb4xPopin.cgu"
                        :illustration="fundingDetails.cb4xPopin.imageZen"
                    />
                    <!-- 4xCB gratuit avec détail du prix  -->
                    <cb4x-modal-content
                        v-else-if="accessoryPrice.price.spreadingPrice4xCbWithoutFees"
                        :header-block="fundingDetails.cb4xPopin.headerBlock"
                        :payment-block="fundingDetails.cb4xPopin.paymentBlock"
                        :payment-simulation-block="fundingDetails.cb4xPopin.paymentSimulationBlock"
                        :how-to-benefit="fundingDetails.cb4xPopin.howToBenefit"
                        :faq="fundingDetails.cb4xPopin.faqBlock"
                        :cgu="fundingDetails.cb4xPopin.cgu"
                        :monthly-price="accessoryPrice.price.spreadingPrice4xCbWithoutFees.monthlyPrice"
                        :first-monthly-price="accessoryPrice.price.spreadingPrice4xCbWithoutFees.firstMonthlyPrice"
                        :one-shot-price="accessoryPrice.price.spreadingPrice4xCbWithoutFees.oneShotPrice"
                        :illustration="fundingDetails.cb4xPopin.imageZen"
                    />
                </template>
                <!-- Payez en 12x, 24x, 36x ou 48x  -->
                <template v-if="accessoryPrice.price.pxfAvailable" #pxf-content>
                    <pxf-modal-content
                        :header-block-dto="fundingDetails.pxfPopin.headerBlockDto"
                        :example-pxf-data="fundingDetails.pxfPopin.examplePxfData"
                        :example-pxf-tab-subtitle="fundingDetails.pxfPopin.examplePxfTabSubtitle"
                        :example-pxf-tab-title="fundingDetails.pxfPopin.examplePxfTabTitle"
                        :version-pxf-data="accessoryPrice.price.versionPxfData"
                        :version-pxf-tab-title="fundingDetails.pxfPopin.versionPxfTabTitle"
                        :pxf-legal-mentions-text="fundingDetails.pxfPopin.pxfLegalMentionsText"
                        :illustration="fundingDetails.pxfPopin.imageZen"
                        :financing-block="fundingDetails.pxfPopin.financingBlock"
                        :cgu="fundingDetails.pxfPopin.cguDto"
                        :how-to-benefit-dto="fundingDetails.pxfPopin.howToBenefitDto"
                    />
                </template>
            </pxf-cb4x-modal>
        </div>

        <eco-part-private-copying
            v-if="accessoryPrice.showEcoParticipationDTO"
            :id="accessoryPrice.ecoParticipationDTO.id + '-modal'"
            :eco-part-label="accessoryPrice.ecoParticipationDTO.ecoParticipationLabel"
            :eco-part-link-label="accessoryPrice.ecoParticipationDTO.ecoParticipationLinkLabel"
            :eco-part-modal="accessoryPrice.ecoParticipationDTO.ecoParticipationModal"
            :private-copying-label="accessoryPrice.ecoParticipationDTO.privateCopyingLabel"
            :private-copying-link="accessoryPrice.ecoParticipationDTO.privateCopyingLink"
            :private-copying-link-label="accessoryPrice.ecoParticipationDTO.privateCopyingLinkLabel"
            :target="accessoryPrice.ecoParticipationDTO.ecoParticipationModal.target"
        />

        <!--/* Les garanties légales */-->
        <p v-if="showGuaranteeLegalMentions" class="small" v-html="guaranteeLegalMentionsLabel" />
    </div>
</template>

<script>
import Cb4xPxfMention from "../../common/fragments/mobile/Cb4xPxfMention.vue";
import PxfCb4xModal from "../common/components/PxfCb4xModal.vue";
import Cb4xModalContent from "../common/components/Cb4xModalContent.vue";
import PayingDetailCb4xModalContent from "../common/components/PayingDetailCb4xModalContent.vue";
import PxfModalContent from "../common/components/PxfModalContent.vue";
import PromoPrixTerminal from "../common/PromoPrixTerminal.vue";
import EcoPartPrivateCopying from "../common/fragments/EcoPartPrivateCopying.vue";

export default {
  components: {
      EcoPartPrivateCopying,
      PromoPrixTerminal, Cb4xModalContent, PxfCb4xModal, Cb4xPxfMention, PayingDetailCb4xModalContent, PxfModalContent,
  },
    props: {
        accessoryPrice: {
            type: Object,
            required: true
        },
        fundingDetails: {
            type: Object,
            required: true
        },
        showGuaranteeLegalMentions: {
            type: Boolean,
            required: false,
            default: false
        },
        guaranteeLegalMentionsLabel: {
            type: String,
            required: false,
            default: undefined
        }
    }
}
</script>
